import styled from 'styled-components';
import {
  color,
  space,
  typography,
  layout,
  background,
  border,
  position,
  shadow,
  flexbox,
} from 'styled-system';

interface SvgProps {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
  minHeight?: string;
  maxHeight?: string;
  minWidth?: string;
  maxWidth?: string;
  display?: string;
  flex?: string;
  m?: string;
  p?: string;
  transition?: boolean;
}

const StyledSvg = styled.img<SvgProps>`
  transition: ${props => (props.transition ? 'all 500ms ease 0s' : 'none')};
  ${color};
  ${space};
  ${typography};
  ${layout};
  ${background};
  ${border};
  ${position};
  ${shadow};
  ${flexbox};
`;

export default StyledSvg;
